@import '../scss/tokens';
@import '~@sydle/ui-design-system/styles/scss/breakpoints';

:host {
  display: block;

  .link-select {
    color: map-get($tokens, sy-blog-header-link-color);
    text-decoration: none;

    &:hover {
      color: map-get($tokens, sy-blog-header-link-color-hover);
    }
  }

  sy-dropdown[toggle-by='#languages-dropdown'] {
    transform: translate(-20px, 53px) !important;

    @include breakpoint-media-down(md) {
      transform: translate(0, 53px) !important;
    }

    .languages {
      display: flex;
      flex-direction: column;
      margin: 0 10px;
    }

    a {
      padding: var(--sy-spacer-3);
    }
  }

  #languages-dropdown {
    display: flex;
    flex-direction: row-reverse;

    #selected-language-name {
      @include breakpoint-media-down(sm) {
        display: none;
      }
    }

    a {
      display: flex;
      align-items: center;
      height: 100%;
      color: map-get($tokens, sy-blog-header-link-color);
      text-decoration: unset;
      text-wrap: nowrap;
      cursor: pointer;
      sy-icon {
        color: map-get($tokens, sy-blog-header-link-color);

        @include breakpoint-media-down(md) {
          margin-right: var(--sy-spacer-3);
        }
      }

      &:hover {
        $hover-color: map-get($tokens, sy-blog-header-link-color-hover);
        color: $hover-color;

        sy-icon {
          color: $hover-color;
        }
      }
    }
  }
}
